import { TemplateVisibility } from "../../api/BrandTemplateApi";
import "./TemplateStatusBadge.scss";

interface Props {
  visibility?: TemplateVisibility | null;
  className?: string;
}

export default function TemplateStatusBadge({ visibility, className }: Props) {
  const isDraft = visibility === "draft";
  const variant = isDraft ? "draft" : "live";
  const label = isDraft ? "Draft" : "Live";
  return (
    <span className={`template-status-badge ${variant}${className ? ` ${className}` : ""}`}>
      <span className="dot" />
      {label}
    </span>
  );
}
